export enum ImageScalingDirectionEnum {
  AUTO = 'AUTO',
  SCALE_TO_WIDTH = 'SCALE_TO_WIDTH'
}
